import { BaseGetRequest } from './core/baseGetRequest';
import { CustomerContactDetails, CustomerContactDetailsDynamicType } from '../models/customerContactDetails';

export class CustomerContactDetailsRequest extends BaseGetRequest<CustomerContactDetails> {
    constructor() {
        super('users/contact-details', {}, CustomerContactDetailsDynamicType);
    }
}
